
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenSplitTop as ObiScreenSplitTopElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-split-top.js';
 
 
 

 
 export const ObiScreenSplitTop = createComponent({
   react: React,
   tagName: 'obi-screen-split-top',
   elementClass: ObiScreenSplitTopElement,
   events: {
     
   }
  });
 
 